
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  modalController,
} from "@ionic/vue";
import videoModal from "./videoModal.vue";
import footerContactanos from "./footerContactanos.vue";
import headertoolbarstudio from "./header_toolbar_studio.vue";
import { Capacitor } from "@capacitor/core";

export default {
  name: "spotRadio",
  components: {
    IonHeader,
    IonToolbar,
    IonContent,
    IonPage,
    footerContactanos,
    headertoolbarstudio,
  },
  data() {
    return {
      platform: "",
    };
  },
  methods: {
    async openModal() {
      (document.activeElement as HTMLElement | null)?.blur();
      const modal = await modalController.create({
        component: videoModal,
        componentProps: {
          title: "Spot para Radio",
          video: "assets/videos/SpotParaRadio2.m4v",
        },
      });
      return modal.present();
    },
  },
  mounted() {
    this.platform = Capacitor.getPlatform();
  },
};
